import Validator from 'validatorjs';

export default function validatorAttributeFormatter() {
  Validator.setAttributeFormatter(attribute => {
    return attribute
      .split(/(?=[A-Z])/)
      .join(' ')
      .toLowerCase();
  });
}
